import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';

import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IKnmErknmFormJudgmentSubjectData } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormJudgmentSubjectData';

import { DecisionJudgmentCancellationTableBody } from './DecisionJudgmentCancellationTableBody';
import styles from './Judgment.module.scss';

interface IDecisionJudgmentCancellationInfoProps {
  watchOnly: boolean;
  judgmentCancellationItemId: string;
  judgmentCancellationItemName: string;
  formRef: IDecisionFormRef | undefined;
}

export const DecisionJudgmentCancellationInfo = ({
  watchOnly,
  judgmentCancellationItemId,
  judgmentCancellationItemName,
  formRef,
}: IDecisionJudgmentCancellationInfoProps) => {
  return (
    <table width="100%" className={styles.Table}>
      <thead className={styles.CancellationTableHeader}>
        <tr>
          <th className={styles.CancellationTableInformationTitle}>№</th>
          <th></th>
          <th className={styles.CancellationTableInformationTitle}>ПРИНЯТОЕ РАНЕЕ РЕШЕНИЕ</th>
          <th className={styles.CancellationTableInformationTitle}>ОТМЕНА ПРИНЯТОГО РЕШЕНИЯ</th>
          <th className={styles.CancellationTableInformationTitle}>ПОЯСНЕНИЕ</th>
        </tr>
      </thead>
      <tbody>
        <FieldArray name={`${judgmentCancellationItemName}.judgmentSubjectData`}>
          {({ fields }: FieldArrayRenderProps<IKnmErknmFormJudgmentSubjectData, HTMLElement>) => {
            if (!fields.length) {
              return null;
            }

            return fields.map((cancellationSubjectName, cancellationSubjectIndex) => {
              const cancellationSubjectValue: IKnmErknmFormJudgmentSubjectData =
                fields.value?.[cancellationSubjectIndex];
              const cancellationSubjectId = `${judgmentCancellationItemId}.judgmentSubjectData[${cancellationSubjectValue.listId}]`;

              return (
                <DecisionJudgmentCancellationTableBody
                  cancellationSubjectId={cancellationSubjectId}
                  cancellationSubjectName={cancellationSubjectName}
                  cancellationSubjectValue={cancellationSubjectValue}
                  watchOnly={watchOnly}
                  key={cancellationSubjectName}
                  formRef={formRef}
                />
              );
            });
          }}
        </FieldArray>
      </tbody>
    </table>
  );
};
